import React, { useState, useRef } from 'react';
import { Button, Card, Table, TableProps, Space, Pagination, Typography, Tag, Modal, Form, Input, message, Spin } from 'antd';
import { PlusOutlined, FileUnknownOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { IthHelmet, ThEmpty } from '@/components';
import { getMilestonePlanProjectsApi, createMilestonePlanPlmProjectApi, checkMilestonePlanPlmProjectCreateStatusApi } from '@/services/apis';
import { Link, generatePath, useSearchParams } from 'react-router-dom';

const k_PlmProjectCreateStatus = {
    running: 'running',
    completed: 'completed',
    error: 'error',
}

const MilestonePlanList: React.FC = () => {
    const [page, setPage] = useState(1);
    const pageSize = useRef(30);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchParams] = useSearchParams();
    

    const invoiceToken = searchParams.get('token') || '-';

    const { data: projectsData, loading, refresh } = useRequest(
        () => getMilestonePlanProjectsApi(invoiceToken || ''),
        {
            debounceWait: 300,
        }
    );

    const {data: createData, loading: createLoading, run: runCreateProject} = useRequest(createMilestonePlanPlmProjectApi,
        {
            manual: true,
            onSuccess: (res) => {
                // if (res.status === k_PlmProjectCreateStatus.running) {
                checkCreateStatus();
                // }
            }
        }
    );
    const [creatingID, setCreatingID] = useState<number | null>(null);
    const {data: checkData, loading: checkLoading, run: runCheckProjectStatus} = useRequest(checkMilestonePlanPlmProjectCreateStatusApi,
        {
            manual: true,
            onSuccess: (res) => {
                if (res.status === k_PlmProjectCreateStatus.completed) {
                    message.success('项目创建成功');
                    setCreatingID(null);
                    if (statusTimer.current) {
                        clearTimeout(statusTimer.current);
                    }
                    refresh();
                }
            }
        }
    );
    const statusTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

    const checkCreateStatus = () => {
        if (!creatingID) return;
        if (!checkLoading) {
            runCheckProjectStatus(creatingID);
        }
        if (statusTimer.current) {
            clearTimeout(statusTimer.current);
        }
        statusTimer.current = setTimeout(() => {
            checkCreateStatus();
        }, 2000);
    }

    const handleCreateProject = (record: API.MilestonePlan.Project) => {
        if (record.opProjectID || createLoading || creatingID !== null) return
        runCreateProject(record.ID)
        setCreatingID(record.ID);
    };

    const tableColumns: TableProps<API.MilestonePlan.Project>['columns'] = [
        {
            key: 'projectCode',
            dataIndex: 'projectCode',
            title: '项目编号',
            width: 150,
        },
        {
            key: 'projectName',
            dataIndex: 'projectName',
            title: '项目名称',
            width: 300,
            render: (text) => {
                return <Typography.Text>{text || '-'}</Typography.Text>;
            },
        },
        {
            key: 'opProjectID',
            dataIndex: 'opProjectID',
            title: 'PLM项目ID',
            width: 120,
            render: (id) => id || '-',
        },
        {
            key: 'action',
            title: '操作',
            width: 150,
            align: 'center',
            fixed: 'right',
            render: (_, record) => {
                return (
                    <Space>
                        {!!record.opProjectID && (
                            <Link
                                to={{
                                    pathname: generatePath('/projects/:projectID/milestone-plan', {
                                        projectID: record.opProjectID.toString()
                                    }),
                                    search: `?token=${invoiceToken}`
                                }}
                                className="hover:underline text-inherit"
                                target="_blank"
                            >
                                <Button type="primary">
                                    查看
                                </Button>
                            </Link>
                        )}
                        {!record.opProjectID && (
                            <Button type="primary" onClick={() => handleCreateProject(record)}>
                                新建PLM项目
                            </Button>
                        )}
                    </Space>
                );
            },
        },
    ];

    return (
        <div>
            <IthHelmet pageTitle="里程碑计划项目列表" />
            <Spin spinning={loading || createLoading || creatingID !== null} tip={(createLoading || creatingID !== null) ? '创建中' : '数据加载中'}>
                <Card
                    title="里程碑计划项目列表"
                >
                    <Table
                        loading={loading}
                        tableLayout="fixed"
                        rowKey="ID"
                        columns={tableColumns}
                        dataSource={projectsData || []}
                        pagination={false}
                        scroll={{ x: 1200 }}
                        locale={{
                            emptyText: (
                                <ThEmpty
                                    description={
                                        <div className="text-black/50 mt-4">
                                            {!loading && (
                                                <div>
                                                    <p className="mt-4">暂无项目数据</p>
                                                </div>
                                            )}
                                        </div>
                                    }
                                />
                            ),
                        }}
                    />
                </Card>
                {/* {projectsData && projectsData.length > 0 && (
                    <Card style={{ marginTop: 16 }}>
                        <Pagination
                            current={page}
                            onChange={(v) => setPage(v)}
                            total={projectsData.length}
                            pageSize={pageSize.current}
                            showSizeChanger
                            showQuickJumper
                            showTotal={(total) => `共 ${total} 条`}
                            onShowSizeChange={(cur, size) => {
                                pageSize.current = size;
                            }}
                        />
                    </Card>
                )} */}
            </Spin>
        </div>
    );
};

export default MilestonePlanList;
